import axios from 'axios';

import { getAuthorizationHeader } from './auth_service';

export const reportCaseComment = async (body) => {
  let res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/case-comments/`,
    { data: {...body } },
    getAuthorizationHeader()
  );

  return res.data.data;
};


export const getCaseCommentsByCase = async (opt ={},caseId) => {
  let url = `api/case-comments?populate=*&filters[case]=${caseId}`
  
  if(opt.getDocUrl) {
    url = `api/case-comments?populate[documents][populate]=*&populate[account]=*&filters[case]=${caseId}&sort[1]=createdAt`
  }

  let res = await axios.get(
    process.env.REACT_APP_BACKEND_URL + url,
    getAuthorizationHeader()
  );

  return res.data.data
};